import React from "react";
import { UploadFileContainer } from "../../../containers";

const UploadFile = (props) => {
  return <UploadFileContainer {...props} />;
};

export default UploadFile;
